import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText } from '@wordpress/block-editor';
import { useRef, useEffect } from '@wordpress/element';

import Style from './Style';
import blockJson from './block.json';

export default function Edit( props ) {
	const { attributes, setAttributes, clientId, isSelected } = props;
	const {
		content,
		level,
		placeholder,
		subHeadingTypography,
		typography,
		blockId,
	} = attributes;

	// Log attributes as JSON if running on localhost, with copy command
	useEffect( () => {
		if (
			typeof window !== 'undefined' &&
			window.location.hostname.match(
				/^(localhost|127\.|192\.168\.|10\.)/
			)
		) {
			const json = JSON.stringify( attributes, null, 2 );
			// eslint-disable-next-line no-console
			// console.log(json);
		}
	}, [ attributes ] );

	// Destructure fontFamily from subHeadingTypography
	const { fontFamily: subHeadingFontFamily } = subHeadingTypography || {};
	const { fontFamily: headingFontFamily } = typography || {};
	const blockProps = useBlockProps( {
		className: `alpha-heading-blocks alpha-heading-block-${ blockId }`,
	} );

	const contentRef = useRef( null );

	useEffect( () => {
		// Reload Google Fonts when headingFontFamily or subHeadingFontFamily changes
		// console.log([headingFontFamily, subHeadingFontFamily]);
		if ( contentRef.current && Alpine ) {
			if (
				typeof Alpine?.$data( contentRef.current )?.loadGoogleFonts ===
				'function'
			) {
				Alpine?.$data( contentRef.current )?.loadGoogleFonts(
					[ headingFontFamily, subHeadingFontFamily ].filter(
						( f ) => f && f !== 'default'
					)
				);
			}
		}
	}, [ headingFontFamily, subHeadingFontFamily ] );

	// Subheading options
	const {
		enableSubHeading,
		subHeadingContent,
		subHeadingTag = 'span',
		subHeadingPosition = 'above',
	} = attributes;

	useEffect( () => {
		if ( ! attributes.blockId || blockId !== clientId ) {
		setAttributes( { blockId: clientId } );
		}
	}, [ clientId ] );

	const SubHeading =
		enableSubHeading && subHeadingContent ? (
			<RichText
				tagName={ subHeadingTag }
				value={ subHeadingContent }
				allowedFormats={ [ 'core/bold', 'core/italic', 'core/link' ] }
				onChange={ ( value ) =>
					setAttributes( { subHeadingContent: value } )
				}
				placeholder={ __( 'Write subheading…', 'alpha-blocks' ) }
				className="alpha-subheading"
			/>
		) : null;

	return (
		<div { ...blockProps }>
			<Style
				attributes={ attributes }
				blockId={ blockId }
				setAttributes={ setAttributes }
			/>
			<window.InspectorGenerator props={ props } blockJson={ blockJson } />
			<div
				x-data="heading"
				data-font-families={ [
					headingFontFamily,
					subHeadingFontFamily,
				] }
				ref={ contentRef }
			>
				{ subHeadingPosition === 'above' && SubHeading }
				<RichText
					tagName={ `h${ level || 2 }` }
					value={ content }
					allowedFormats={ [
						'core/bold',
						'core/italic',
						'core/link',
					] }
					onChange={ ( value ) =>
						setAttributes( { content: value } )
					}
					placeholder={
						placeholder || __( 'Write heading…', 'alpha-blocks' )
					}
					className="alpha-heading"
				/>
				{ subHeadingPosition === 'below' && SubHeading }
			</div>
		</div>
	);
}
